export const compareActionPlansForLatestView = (
  a: fhir.CarePlan,
  b: fhir.CarePlan,
): number => {
  // Prefer the current active plan; completed plans are the latest fallback.
  if (a.status === 'active' && b.status !== 'active') return -1;
  if (a.status !== 'active' && b.status === 'active') return 1;
  if (a.status === 'completed' && b.status !== 'completed') return -1;
  if (a.status !== 'completed' && b.status === 'completed') return 1;
  if (a.status === 'entered-in-error' && b.status !== 'entered-in-error')
    return 1;
  if (a.status !== 'entered-in-error' && b.status === 'entered-in-error')
    return -1;
  if (!a.period?.end) return -1;
  if (!b.period?.end) return 1;
  return new Date(b.period.end).getTime() - new Date(a.period.end).getTime();
};

export const findLatestActionPlan = (
  carePlans: fhir.CarePlan[] | undefined,
): fhir.CarePlan | undefined =>
  carePlans
    ?.filter(carePlan => carePlan.supportingInfo?.length)
    .slice()
    .sort(compareActionPlansForLatestView)[0];
